export default "__VITE_ASSET__0333fcca__"